import React, { useMemo, useEffect, useState } from "react"

import AddSingleItem from "./AddSingleItem"
import EditSingleItem from "./EditSingleItem"
import { deleteNow } from "helpers/delete_function"
import { axiosbaseurl } from "configure"
import moment from "moment"
import { setUpdatedData } from "helpers/data_setters"
import Loader from "components/Common/Loader"
import AutoTasks from "../Service Master/AutoTasks"
import { usePermissionData } from "AppContext"
import PermittedComponent from "components/Common/PermittedComponent"
import CommonTable from "components/Common/CommonTable"
import { useNavigate } from "react-router-dom"
import Select from "react-select"
import { customStyles } from "helpers/select-styles"

const AllSingleItems = ({
  api_name,
  heading,
  title,
  fieldName,
  serviceCategory = false,
  clientTypes = false,
  services = false,
  isAddDelete = true,
  isAction = true,
  module_id,
  isDelete = true,
}) => {
  const [table_data, settable_data] = useState([])
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const getDatas = async () => {
      try {
        setLoading(true)
        const response = await axiosbaseurl.get(`/${api_name}`)
        if (response.data.success) {
          settable_data(response.data.data)
        }
      } catch (error) {
        console.log(error)
      } finally {
        setLoading(false)
      }
    }
    getDatas()
  }, [])

  document.title = `${heading} | Peacock Accountants Limited`

  return (
    <>
      {loading && <Loader />}

      <TableComponent
        table_data={table_data}
        settable_data={settable_data}
        api_name={api_name}
        heading={heading}
        fieldName={fieldName}
        title={title}
        serviceCategory={serviceCategory}
        clientTypes={clientTypes}
        services={services}
        isAddDelete={isAddDelete}
        isAction={isAction}
        module_id={module_id}
        isDelete={isDelete}
      />
    </>
  )
}

const TableComponent = ({
  table_data,
  settable_data,
  api_name,
  heading,
  fieldName,
  serviceCategory,
  title,
  clientTypes,
  isAddDelete,
  isAction,
  isDelete,
  module_id,
  services,
}) => {
  const [addShow, setAddShow] = useState(false)
  const [editShow, setEditShow] = useState(false)
  const [itemName, setItemName] = useState("")
  const [budgetAmt, setBudgetAmt] = useState("")
  const [correspondenceType, setCorrespondenceType] = useState("")
  const [item_id, setItemId] = useState("")

  const { checkAccess, permissions } = usePermissionData()

  const navigate = useNavigate()

  // Non-editable service guard — id 2 in service-master is locked (uses module_id directly to avoid TDZ)
  const isLockedService = id => module_id === 6 && Number(id) === 2

  const handleStatus = async (status, id) => {
    try {
      if (isLockedService(id)) {
        swal(
          "",
          "This service (ID 2) is non-editable and cannot be updated.",
          "warning"
        )
        return
      }
      if (status) {
        const response = await axiosbaseurl.patch(`/${api_name}/${id}/status`, {
          status,
        })
        if (response.data.success) {
          settable_data(
            setUpdatedData(
              table_data,
              response.data.data || response.data.status,
              "edit",
              "Status "
            )
          )
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const handleDelete = async id => {
    try {
      if (isLockedService(id)) {
        swal(
          "",
          "This service (ID 2) is non-editable and cannot be deleted.",
          "warning"
        )
        return
      }
      const response = await axiosbaseurl.delete(`/${api_name}/${id}`)
      if (response.data.success)
        settable_data(
          setUpdatedData(
            table_data,
            response.data.data || response.data.status,
            "delete"
          )
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  const handleChangeClientType = async (c_type, id, serviceName) => {
    try {
      if (isLockedService(id)) {
        swal(
          "",
          "This service (ID 2) is non-editable and cannot be updated.",
          "warning"
        )
        return
      }
      const response = await axiosbaseurl.put(`/service-master/${id}`, {
        serviceName,
        clientTypeId: c_type,
      })
      if (response.data.success)
        settable_data(
          setUpdatedData(
            table_data,
            response.data.data || response.data.status,
            "edit",
            "Client Type "
          )
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  const handleChangeServiceCatergory = async (s_type, id, serviceName) => {
    try {
      if (isLockedService(id)) {
        swal(
          "",
          "This service (ID 2) is non-editable and cannot be updated.",
          "warning"
        )
        return
      }
      const response = await axiosbaseurl.put(`/service-master/${id}`, {
        serviceName,
        serviceCategory: s_type,
      })
      if (response.data.success)
        settable_data(
          setUpdatedData(
            table_data,
            response.data.data || response.data.status,
            "edit",
            "Service Category "
          )
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  const handleChangeMeetingStatus = async (id, isMeeting, workType) => {
    try {
      const response = await axiosbaseurl.put(`/work-type/${id}`, {
        isMeeting,
        workType,
      })
      if (response.data.success)
        settable_data(
          setUpdatedData(
            table_data,
            response.data.data || response.data.status,
            "edit",
            "Meeting Status "
          )
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  const handleChangeCorrespondenceType = async (
    id,
    correspondenceType,
    workType
  ) => {
    try {
      const response = await axiosbaseurl.put(`/work-type/${id}`, {
        correspondenceType,
        workType,
      })
      if (response.data.success)
        settable_data(
          setUpdatedData(
            table_data,
            response.data.data || response.data.status,
            "edit",
            "Correspondence Type "
          )
        )
    } catch (error) {
      console.log(error)
      swal("", error.response.data.message || "Something went Wrong", "error")
    }
  }

  // conditions to manage specific changes module wise
  const isServiceMaster = module_id === 6 || false
  const isServiceTagMaster = module_id === 31 || false
  const isBudgetMaster = module_id === 29 || false
  const isWorkTypeMaster = module_id === 10 || false

  // columns
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        filterable: true,
        disableFilters: true,
        className: " text-center",
        Cell: cellProps => <span>{cellProps.row.index + 1}</span>,
      },
      {
        Header: title,
        accessor: fieldName,
        disableFilters: true,
        filterable: true,
      },

      // only for work type
      ...(isWorkTypeMaster
        ? [
            {
              Header: "Meeting",
              accessor: "isMeeting",
              disableFilters: true,
              filterable: true,
              className: "text-center",
              Cell: cellProps => {
                return (
                  <div className="form-switch ">
                    <input
                      type="checkbox"
                      className="form-check-input fs-4"
                      checked={cellProps.row.original.isMeeting === true}
                      disabled={!checkAccess(module_id, "edit")}
                      onChange={e =>
                        handleChangeMeetingStatus(
                          cellProps.row.original.id,
                          e.target.checked,
                          cellProps.row.original.workType
                        )
                      }
                    />
                  </div>
                )
              },
            },
          ]
        : []),

      ...(isWorkTypeMaster
        ? [
            {
              Header: "Correspondence Type",
              accessor: "correspondenceType",
              disableFilters: true,
              filterable: true,
              className: "text-center",
              Cell: cellProps => {
                const currentValue = cellProps.row.original.correspondenceType
                const selectedValue =
                  typeof currentValue === "string" ? currentValue : ""

                return (
                  <div className="text-center">
                    <select
                      onChange={e =>
                        handleChangeCorrespondenceType(
                          cellProps.row.original.id,
                          e.target.value,
                          cellProps.row.original.workType
                        )
                      }
                      className={`badge fs-6 border-0 status_select_dropdown bg-light`}
                      disabled={!checkAccess(module_id, "edit")}
                      value={selectedValue}
                      style={{ width: "210px" }}
                    >
                      {!selectedValue && (
                        <option value="">Select Correspondence</option>
                      )}
                      <option value="Internal Correspondence">
                        Internal Correspondence
                      </option>
                      <option value="External Correspondence">
                        External Correspondence
                      </option>
                      <option value="N/A">N/A</option>
                    </select>
                  </div>
                )
              },
            },
          ]
        : []),

      ...(isServiceTagMaster
        ? [
            {
              Header: "Applicable Services",
              accessor: "serviceIds",
              disableFilters: true,
              filterable: true,
              className: "text-center",
              Cell: cellProps => {
                const currentServiceIds =
                  cellProps.row.original.serviceIds || []

                const selectedOptions = currentServiceIds
                  .map(id => {
                    const found = services.find(s => s.value === id)
                    return found || { value: id, label: `ID: ${id}` }
                  })
                  .filter(Boolean)

                return (
                  <div style={{ minWidth: "250px" }}>
                    <Select
                      value={selectedOptions}
                      onChange={async selected => {
                        const selectedIds = selected
                          ? selected.map(s => s.value)
                          : []

                        try {
                          const response = await axiosbaseurl.put(
                            `/${api_name}/${cellProps.row.original.id}`,
                            {
                              tagName: cellProps.row.original.tagName,
                              serviceIds: selectedIds,
                            }
                          )

                          if (response.data.success) {
                            // Update table data
                            settable_data(prev =>
                              prev.map(item =>
                                item.id === cellProps.row.original.id
                                  ? { ...item, serviceIds: selectedIds }
                                  : item
                              )
                            )
                          }
                        } catch (error) {
                          console.error(error)
                          swal("", "Failed to update services", "error")
                        }
                      }}
                      options={services}
                      styles={customStyles}
                      isMulti
                      placeholder="Select services..."
                      closeMenuOnSelect={false}
                      menuPortalTarget={document.body} // ← This is the key fix
                      menuPosition="fixed" // ← Recommended with portal
                    />
                  </div>
                )
              },
            },
          ]
        : []),

      // only for service master
      ...(isServiceMaster
        ? [
            {
              Header: "Client Type",
              accessor: "clientType",
              disableFilters: true,
              filterable: true,
              className: "text-center",
              Cell: cellProps => {
                return (
                  <div className="text-center">
                    <select
                      onChange={e =>
                        handleChangeClientType(
                          e.target.value,
                          cellProps.row.original.id,
                          cellProps.row.original.serviceName
                        )
                      }
                      className={`badge fs-6 border-0 status_select_dropdown  bg-secondary`}
                      disabled={
                        !checkAccess(module_id, "edit") ||
                        isLockedService(cellProps.row.original.id)
                      }
                      value={cellProps.row.original.clientTypeId}
                    >
                      {clientTypes?.map(item => (
                        <option key={item.id} value={item.id}>
                          {item.clientType}
                        </option>
                      ))}
                      <option value={0}>Universal</option>
                    </select>
                  </div>
                )
              },
            },
            {
              Header: "Category",
              accessor: "serviceCategory",
              disableFilters: true,
              filterable: true,
              className: "text-center",
              Cell: cellProps => {
                return (
                  <div className="text-center">
                    <select
                      onChange={e =>
                        handleChangeServiceCatergory(
                          e.target.value,
                          cellProps.row.original.id,
                          cellProps.row.original.serviceName
                        )
                      }
                      className={`badge fs-6 border-0 status_select_dropdown  bg-light`}
                      disabled={
                        !checkAccess(module_id, "edit") ||
                        isLockedService(cellProps.row.original.id)
                      }
                      value={cellProps.row.original.serviceCategory}
                      style={{ width: "170px" }}
                    >
                      {!cellProps.row.original.serviceCategory && (
                        <option value={0}>Select Category</option>
                      )}
                      {serviceCategory?.map(item => (
                        <option key={item.id} value={item.name}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                )
              },
            },
          ]
        : []),

      ...(isBudgetMaster
        ? [
            {
              Header: "Cost Per Hour (£)",
              accessor: "value",
              disableFilters: true,
              filterable: true,
            },
            {
              Header: "Last Updated At",
              accessor: "updatedAt",
              disableFilters: true,
              filterable: true,
              Cell: cellProps => {
                return (
                  <span>
                    {moment(cellProps.row.original.updatedAt).format(
                      "DD MMM YYYY | hh:mm A"
                    )}
                  </span>
                )
              },
            },
          ]
        : []),

      {
        Header: "Created At",
        disableFilters: true,
        filterable: true,
        Cell: cellProps => {
          return (
            <span>
              {moment(cellProps.row.original.createdAt).format(
                "DD MMM YYYY | hh:mm A"
              )}
            </span>
          )
        },
      },

      {
        Header: "Status",
        disableSort: true,
        accessor: "status",
        disableFilters: true,
        filterable: true,
        className: "text-center",
        Cell: cellProps => {
          return (
            <div className="text-center">
              <select
                onChange={e =>
                  handleStatus(e.target.value, cellProps.row.original.id)
                }
                disabled={
                  !checkAccess(module_id, "edit") ||
                  isLockedService(cellProps.row.original.id)
                }
                className={`badge fs-6 border-0 status_select_dropdown 
                                    bg-${
                                      cellProps.row.original.status == "Active"
                                        ? "green"
                                        : "danger"
                                    }`}
                value={cellProps.row.original.status}
              >
                <option value="Active">Active</option>
                <option value="InActive">InActive</option>
              </select>
            </div>
          )
        },
      },
      ...(isAction
        ? [
            {
              Header: "Action",
              disableFilters: true,
              disableSort: true,
              accessor: "view",
              className: "  text-center",
              Cell: cellProps => {
                return (
                  <div className="text-start">
                    {checkAccess(module_id, "edit") &&
                      !isLockedService(cellProps.row.original.id) && (
                        <button
                          onClick={() => {
                            setEditShow(true)
                            setItemName(cellProps.row.original[fieldName])
                            setItemId(cellProps.row.original.id)

                            if (isBudgetMaster) {
                              setBudgetAmt(cellProps.row.original.value)
                            }
                          }}
                          className={`btn btn-success bg-green  btn-sm me-2`}
                        >
                          <i
                            className={`fas fa-pen ${
                              !isServiceMaster && "me-1"
                            }`}
                          ></i>{" "}
                          {isServiceMaster ? "" : "Edit"}
                        </button>
                      )}

                    {isServiceMaster &&
                      (cellProps.row.original.serviceCategory ===
                        "Billiable and scheduled" ||
                        cellProps.row.original.serviceCategory ===
                          "Non-Billiable and scheduled") && (
                        <AutoTasks
                          serviceName={cellProps.row.original[fieldName]}
                          serviceId={cellProps.row.original.id}
                          frequencyType={cellProps.row.original.frequency}
                          savedTasks={cellProps.row.original.autoTasks}
                        />
                      )}

                    {/* Delete btn */}
                    {/* {
                                            checkAccess(module_id, 'remove') && isAddDelete && isDelete &&
                                            <button
                                                // onClick={() => deleteNow(() => handleDelete(cellProps.row.original.id))}
                                                onClick={() => {
                                                    const notAllowed = [1, 2, 3];

                                                    if (notAllowed.includes(cellProps.row.original.id) && module_id === 14) {
                                                        swal("",
                                                            "Unable to delete the Client Type, it is linked with Client Module",
                                                            "warning")
                                                        return;
                                                    }

                                                    deleteNow(() => handleDelete(cellProps.row.original.id))
                                                }}
                                                className="btn btn-danger btn-sm ml-10"
                                            >
                                                <i className="fas fa-trash-alt"></i>
                                            </button>
                                        } */}
                  </div>
                )
              },
            },
          ]
        : []),
    ],
    [table_data, clientTypes, services, permissions]
  )

  // table data
  const data = useMemo(() => table_data, [table_data])

  return (
    <>
      <PermittedComponent isAccess={checkAccess(module_id, "view")}>
        <CommonTable
          columns={columns}
          data={data}
          isResizeTable={isAddDelete}
          heading={heading}
        >
          <div>
            {checkAccess(module_id, "add") && isAddDelete && (
              <button
                onClick={() => setAddShow(true)}
                className="btn btn-primary bg-blue ms-3 text-capitalize"
              >
                <i className="fas fa-plus me-2"></i>
                Add {heading}
              </button>
            )}

            <button
              onClick={() => navigate(-1)}
              className="btn btn-secondary bg-dark ms-3"
            >
              <i className="fas fa-arrow-left me-3"></i>
              Back
            </button>
          </div>
        </CommonTable>

        <AddSingleItem
          show={addShow}
          setShow={setAddShow}
          settable_data={settable_data}
          itemName={itemName}
          setItemName={setItemName}
          heading={heading}
          api_name={api_name}
          fieldName={fieldName}
          // for budget master only
          isBudgetMaster={isBudgetMaster}
          budgetAmt={{ value: budgetAmt, setValue: setBudgetAmt }}
          // for work type master only
          isWorkTypeMaster={isWorkTypeMaster}
          correspondenceType={{
            value: correspondenceType,
            setValue: setCorrespondenceType,
          }}
        />

        <EditSingleItem
          show={editShow}
          setShow={setEditShow}
          settable_data={settable_data}
          itemName={itemName}
          setItemName={setItemName}
          item_id={item_id}
          heading={heading}
          api_name={api_name}
          fieldName={fieldName}
          // for budget master only
          isBudgetMaster={isBudgetMaster}
          budgetAmt={{ value: budgetAmt, setValue: setBudgetAmt }}
        />
      </PermittedComponent>
    </>
  )
}

export default AllSingleItems
